import { atom } from 'jotai/vanilla';
import { atomFamily } from 'jotai/vanilla/utils';
import type { ModelId } from 'balus-common';
import type { Point, Size } from '@view-model/models/common/basic';

export type UploadingFileContainer = {
  id: string;
  filename: string;
  position: Point;
  size: Size;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const uploadingFileContainersAtomFamily = atomFamily((_modelId: ModelId) => atom<UploadingFileContainer[]>([]));
